module.exports = __webpack_public_path__ + "img/jm.40586318.png";